
class AuthorizationError extends Error {
  static errorName = 'authentification_error'
  constructor (...args) {
    super(...args)
    this.errorName = AuthorizationError.errorName
  }
}

class ResourceNotFound extends Error {
  static errorName = 'resource_not_found'
  constructor (...args) {
    super(...args)
    this.errorName = ResourceNotFound.errorName
  }
}

class ServerError extends Error {
  static errorName = 'server_error'
  constructor (...args) {
    super(...args)
    this.errorName = ServerError.errorName
  }
}

export { AuthorizationError, ResourceNotFound, ServerError }



// WEBPACK FOOTER //
// ./src/components/error_handling/errors.js